import { getBlob, getVLPBlob } from "./networkService";
import { saveAs } from "file-saver";

export async function getCoc(recordId) {
  let blob = await getBlob(`/reports/coc/${recordId}`);
  saveAs(blob, `${recordId}-ChainOfCustody.pdf`);
}

export async function getLabReport(orderNumber, extension) {
  let blob = await getBlob(`/reports/lab/${orderNumber}/extension/${extension}`);
  const ext = extension.toLowerCase();
  saveAs(blob, `${orderNumber}.${ext}`);
}

export async function getInvoiceReport(invoiceNumber) {
  let blob = await getBlob(`/reports/invoice/${invoiceNumber}`);
  saveAs(blob, `${invoiceNumber}.pdf`);
}


export async function getPoolCoCReport(client) {
  let blob = await getVLPBlob(`api/vlp/user-routes/coc/${client}`);
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank");
  saveAs(blob, `${client}.pdf`);
}
